import React from "react";
import { ReactComponent as NoDataIcon } from "../assests/nodata.svg";
import { cn } from "@/lib/utils";

const Nodata = ({ text = "No data to show", className }) => {
  return (
    <div className={cn("flex flex-col items-center w-full pt-20", className)}>
      {/* Image */}
      <div className="flex justify-center items-center mb-3 dark:text-gray-400">
        <NoDataIcon className="w-50 h-50 sm:w-48 sm:h-48 md:w-56 md:h-56" />
      </div>

      {/* Text */}
      <p className="text-center text-sm md:text-base">{text}</p>
    </div>
  );
};

export default Nodata;
